import gestopAPI from 'utils/gestopAPI';
import { errorProcessor } from 'utils/processors';

const executeRequest = async (request, successCb, errorCb) => {
    try {
        const response = await request();
        successCb?.(response.data);
    } catch (error) {
        errorCb?.(errorProcessor(error?.response?.data));
    }
};

export const ApiAppSettingsGet = (successCb, errorCb) => executeRequest(() => gestopAPI.get('admin/appsettings.json'), successCb, errorCb);

export const ApiAppSettingsUpdate = (payload, successCb, errorCb) =>
    executeRequest(() => gestopAPI.put('admin/appsettings.json', payload), successCb, errorCb);

export const ApiAppSettingsUploadBranding = (payload, successCb, errorCb) =>
    executeRequest(
        () => gestopAPI.post('admin/appsettings/branding.json', payload, { headers: { 'Content-Type': 'multipart/form-data' } }),
        successCb,
        errorCb
    );

export const ApiAppSettingsTestEmail = (payload, successCb, errorCb) =>
    executeRequest(() => gestopAPI.post('admin/appsettings/testemail.json', payload), successCb, errorCb);
